import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const { user, logout } = useAuth();
  const location = useLocation();

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <div className="navbar">
      <h1>DMS Syndication Platform</h1>
      <nav>
        <Link to="/" className={isActive('/')}>Dashboard</Link>
        <Link to="/profile" className={isActive('/profile')}>Profile</Link>
        <Link to="/licensing" className={isActive('/licensing')}>Licensing</Link>
        {!user?.platform_agreement_signed && (
          <Link to="/agreement" className={isActive('/agreement')}>Agreement</Link>
        )}
        <button onClick={logout}>Logout</button>
      </nav>
    </div>
  );
}
